import React from "react";
import logger from "logger";
import ArcheryTasklet from "./Tasklets/ArcheryTasklet.js";
import CGBuffTasklet from "./Tasklets/CGBuffTasklet.js";
import ChestOpenTasklet from "./Tasklets/ChestOpenTasklet.js";
import ClaimRewardsTasklet from "./Tasklets/ClaimRewardsTasklet.js";
import DownloadLbsTasklet from "./Tasklets/DownloadLbsTasklet.js";
import EBKTasklet from "./Tasklets/EBKTasklet.js";
import EBKV2Tasklet from "./Tasklets/EBKV2Tasklet.js";
import ECHSTasklet from "./Tasklets/ECHSTasklet.js";
import GearSortTasklet from "./Tasklets/GearSortTasklet.js";
import GKRunTasklet from "./Tasklets/GKRunTasklet.js";
import HeroUpgrader from "./Tasklets/HeroUpgrader.js";
import MiningTasklet from "./Tasklets/MiningTasklet.js";
import ReassignRssTasklet from "./Tasklets/ReassignRssTasklet.js";
import ReassignTroopsTasklet from "./Tasklets/ReassignTroopsTasklet.js";
import RecallMinesTasklet from "./Tasklets/RecallMinesTasklet.js";
import ShardsStealerTasklet from "./Tasklets/ShardsStealerTasklet.js";
import SkillEnrollerTasklet from "./Tasklets/SkillEnrollerTasklet.js";
import TatTasklet from "./Tasklets/TatTasklet.js";
import TowerEventsTasklet from "./Tasklets/TowerEventsTasklet.js";
import UpgradeBuildingsTasklet from "./Tasklets/UpgradeBuildingsTasklet.js";
import UpgradeMount from "./Tasklets/UpgradeMount.js";
import WheelTasklet from "./Tasklets/WheelTasklet.js";
import WorldBossTasklet from "./Tasklets/WorldBossTasklet.js";
import OpenSCHSMapsTasklet from "./Tasklets/OpenSCHSMapsTasklet.js";
import CustomECHSTasklet from "./Tasklets/CustomECHSTasklet.js";
import CustomCHSTasklet from "./Tasklets/CustomCHSTasklet.js";
import CustomSCHSTasklet from "./Tasklets/CustomSCHSTasklet.js";

export default function(props) {
  const { task } = props;
  let returnObj = null;

  if (task.taskname === "upgrademounttomax") {
    returnObj = (
      <UpgradeMount
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "gearsort") {
    returnObj = (
      <GearSortTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "echsbossrun") {
    returnObj = (
      <ECHSTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "tat") {
    returnObj = (
      <TatTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "ebkrun") {
    returnObj = (
      <EBKTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "ebkv2run") {
    returnObj = (
      <EBKV2Tasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "wheel") {
    returnObj = (
      <WheelTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "archery") {
    returnObj = (
      <ArcheryTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "cgbuff") {
    returnObj = (
      <CGBuffTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "upgradebuildings") {
    returnObj = (
      <UpgradeBuildingsTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "gkrun") {
    returnObj = (
      <GKRunTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "mining") {
    returnObj = (
      <MiningTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "worldboss") {
    returnObj = (
      <WorldBossTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "towerevents") {
    returnObj = (
      <TowerEventsTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "downloadlbsevents") {
    returnObj = (
      <DownloadLbsTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "chestopen") {
    returnObj = (
      <ChestOpenTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "claimrewards") {
    returnObj = (
      <ClaimRewardsTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "reassigntroops") {
    returnObj = (
      <ReassignTroopsTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "reassignrss") {
    returnObj = (
      <ReassignRssTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "shardstealer") {
    returnObj = (
      <ShardsStealerTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "recallmines") {
    returnObj = (
      <RecallMinesTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "heroupgrader") {
    returnObj = (
      <HeroUpgrader
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "skillenroller") {
    returnObj = (
      <SkillEnrollerTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "openschsmaps") {
    returnObj = (
      <OpenSCHSMapsTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "echscustomrun") {
    returnObj = (
      <CustomECHSTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "chscustomrun") {
    returnObj = (
      <CustomCHSTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }
  if (task.taskname === "schscustomrun") {
    returnObj = (
      <CustomSCHSTasklet
        task={task}
        showOwner={props.showOwner}
        showUser={props.showUser}
      />
    );
  }

  return returnObj;
}
